import React, { RefObject, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'react-bootstrap-icons';
import classNames from 'classnames';

import { constructUrl } from '@/lib/utils';
import { createUseThemedStyles } from '@/hooks';
import { SearchInput } from './search-input';

const useStyles = createUseThemedStyles((theme) => ({
	globalSearchOuter: {
		position: 'relative',
		alignItems: 'center',
	},
	searchButton: {
		top: 0,
		right: 0,
		bottom: 0,
		padding: '0 12px',
		position: 'absolute',
		borderTopRightRadius: 2,
		borderBottomRightRadius: 2,
		backgroundColor: theme.colors.white,
		border: `1px solid ${theme.colors.gray500}`,
	},
}));

interface HeaderSearchProps {
	className?: string;
}

export const HeaderSearch = React.forwardRef(
	(
		{ className }: HeaderSearchProps,
		ref: ((instance: HTMLDivElement | null) => void) | RefObject<HTMLDivElement> | null | undefined
	) => {
		const classes = useStyles();
		const navigate = useNavigate();
		const [inputValue, setInputValue] = useState('');

		const handleSearchSubmit = useCallback(
			(query: string) => {
				navigate(constructUrl('/search', { query, from: 0 }));
			},
			[navigate]
		);

		return (
			<div ref={ref} className={classNames(classes.globalSearchOuter, className)}>
				<SearchInput
					hideIcon
					value={inputValue}
					onChange={({ currentTarget }) => {
						setInputValue(currentTarget.value);
					}}
					onKeyDown={({ key }) => {
						if (key === 'Enter') {
							handleSearchSubmit(inputValue);
						}
					}}
				/>
				<button
					className={classes.searchButton}
					onClick={() => {
						handleSearchSubmit(inputValue);
					}}
				>
					<Search className="d-flex text-primary" />
				</button>
			</div>
		);
	}
);
